export default function Cross({ className }: { className?: string }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='41' height='41' viewBox='0 0 41 41' fill='none' className={className}>
      <path
        d='M25.0447 16.1133L15.6113 25.5466'
        stroke='#232221'
        strokeWidth='1.74563'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.0447 25.5466L15.6113 16.1133'
        stroke='#232221'
        strokeWidth='1.74563'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.3262 35.8301V35.8301C12.0412 35.8301 5.32617 29.1151 5.32617 20.8301V20.8301C5.32617 12.5451 12.0412 5.83008 20.3262 5.83008V5.83008C28.6112 5.83008 35.3262 12.5451 35.3262 20.8301V20.8301C35.3262 29.1151 28.6112 35.8301 20.3262 35.8301Z'
        stroke='#232221'
        strokeWidth='1.74563'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
